import { useRouter } from 'next/router';
import { useAchievementTypes, useReduxState } from 'hooks';
import { SortBy } from 'components/common';
import { DropdownSelectable } from 'components/common/dropdown';
import { UsersCompletionFilter } from 'components/users';

import type { Achievement } from 'shared-types';

type AchievementTypes = Achievement['type'] | 'all';

const ProfileAchievementsHeader = () => {
  const { messages } = useReduxState();

  const achievementTypes = useAchievementTypes();

  const router = useRouter();

  const updateAchievementType = async (value: AchievementTypes) => {
    const queryParams = router.query || {};
    if (value === 'all') delete queryParams.achievementType;
    else queryParams.achievementType = value;

    router.replace({ query: queryParams }, undefined, { shallow: true });
  };

  const updateCompletionStatus = async ({ achievementCompletionStatus }) => {
    const queryParams = router.query || {};
    if (achievementCompletionStatus === 'all') {
      delete queryParams.completionStatus;
    } else {
      queryParams.completionStatus = achievementCompletionStatus;
    }

    router.replace({ query: queryParams }, undefined, { shallow: true });
  };

  const updateSortBy = async ({ sortBy }: { sortBy: 'date' | 'title' }) => {
    const queryParams = router.query || {};
    if (sortBy === 'title') delete queryParams.sortBy;
    else queryParams.sortBy = sortBy;

    router.replace({ query: queryParams }, undefined, { shallow: true });
  };

  const type = (router.query.achievementType as AchievementTypes) || 'all';
  const sortBy = (router.query.sortBy as 'date' | 'title') || 'title';

  return (
    <div className="wrapper">
      <UsersCompletionFilter
        disabled={false}
        updateUsers={updateCompletionStatus}
        view="achievement"
      />

      <DropdownSelectable
        align="left"
        category="lighter"
        defaultText={`${messages.commonSelect}...`}
        defaultValue={type}
        dropdownTextMinWidth="120px"
        onChange={updateAchievementType}
        options={[
          { text: messages.commonAll, value: 'all' },
          ...Object.keys(achievementTypes).map((type) => ({
            text: achievementTypes[type].title,
            value: type
          }))
        ]}
        selectedValueBefore={`${messages.commonType}:`}
        showSelectedText={true}
        size="header"
        titleMaxWidth={120}
        value={type}
      />

      <SortBy
        onChange={updateSortBy}
        options={[
          { text: messages.commonCompletion, value: 'date' },
          { text: messages.commonTitle, value: 'title' }
        ]}
        value={sortBy}
      />

      <style jsx>{`
        .wrapper {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
      `}</style>
    </div>
  );
};

export default ProfileAchievementsHeader;
